export default class Exception extends Error {
  code = "";
  exception = null;
  error = null;

  constructor(message, code, error = null) {
    super(message);
    this.code = code;
    this.exception = true;
    this.error = error;
  }
}
